// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"640":"182629b2","1342":"6de6a414","9237":"bc06aa92"}[chunkId] + ".chunk.css";
};